import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/loading",
    name: "loading",
    component: () => import("../views/LoadingView.vue"),
  },
  {
    path: "/loading",
    name: "loading",
    component: () => import("../views/LoadingView.vue"),
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/page",
    name: "page",
    component: () => import("../views/PageView.vue"),
    children: [
      {
        path: "/jianjie",
        name: "jianjie",
        component: () => import("../views/JianJie.vue"),
      },
      {
        path: "/huiben",
        component: () => import("../views/HuiBen.vue"),
        children: [
          {
            path: "one",
            name: "one",
            component: () => import("../views/huiben/OneView.vue"),
            meta: {
              index: 0
            }
          },
          {
            path: "two",
            name: "two",
            component: () => import("../views/huiben/TwoView.vue"),
            meta: {
              index: 1
            }
          },
          {
            path: "three",
            name: "three",
            component: () => import("../views/huiben/ThreeView.vue"),
            meta: {
              index: 2
            }
          }, {
            path: "four",
            name: "four",
            component: () => import("../views/huiben/FourView.vue"),
            meta: {
              index: 3
            }
          },
          {
            path: "five",
            name: "five",
            component: () => import("../views/huiben/FiveView.vue"),
            meta: {
              index: 4
            }
          },
          {
            path: "six",
            name: "six",
            component: () => import("../views/huiben/SixView.vue"),
            meta: {
              index: 5
            }
          },
          {
            path: '',
            redirect: 'one'
          }
        ]
      },
      {
        path: "/xiazai",
        name: "xiazai",
        component: () => import("../views/XiaZai.vue"),
      },
    ]
  },
  {
    path: "/",
    redirect: "/xiazai"
  },
  {
    path: "/:pathMatch(.*)",
    component: () => import("../views/404.vue")
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

export default router;
